(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aa-appshowcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('de-wallbox-app-showcase')) {
    customElements.define('de-wallbox-app-showcase', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const controller = this.controller;
        queueMicrotask(() => {
          if (!this.isConnected || controller.signal.aborted) return;
          this.screens = this.querySelector('[data-screens]');
          this.slides = Array.from(this.querySelectorAll('[data-screen]'));
          this.features = Array.from(this.querySelectorAll('[data-feature]'));
          this.dots = Array.from(this.querySelectorAll('[data-dot]'));
          if (!this.screens || !this.slides.length) return;
          this.index = 0;
          this.lastWidth = this.screens.clientWidth;
          this.features.forEach(button => { button.disabled = false; });
          const dotGroup = this.querySelector('[data-dots]');
          if (dotGroup) dotGroup.hidden = false;
          this.update(0);
          this.screens.scrollTo({ left: 0, behavior: 'instant' });
          const options = { signal: controller.signal };
          this.addEventListener('click', event => {
            const feature = event.target.closest('[data-feature]');
            const dot = event.target.closest('[data-dot]');
            if (feature && this.features.includes(feature)) this.go(Number(feature.dataset.feature));
            if (dot && this.dots.includes(dot)) this.go(Number(dot.dataset.dot));
          }, options);
          this.addEventListener('keydown', event => {
            if (!event.target.closest('[data-screens], [data-feature], [data-dot]')) return;
            let next;
            if (event.key === 'ArrowRight') next = (this.index + 1) % this.slides.length;
            if (event.key === 'ArrowLeft') next = (this.index - 1 + this.slides.length) % this.slides.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = this.slides.length - 1;
            if (next === undefined) return;
            event.preventDefault();
            this.go(next);
          }, options);
          this.screens.addEventListener('scroll', () => {
            if (this.frame) cancelAnimationFrame(this.frame);
            this.frame = requestAnimationFrame(() => {
              this.frame = null;
              const width = this.screens.clientWidth;
              if (width) this.update(Math.min(this.slides.length - 1, Math.max(0, Math.round(this.screens.scrollLeft / width))));
            });
          }, { ...options, passive: true });
          this.addEventListener('shopify:block:select', event => {
            const index = this.features.indexOf(event.target.closest('[data-feature]'));
            if (index !== -1) this.go(index, false);
          }, options);
          this.observer = new ResizeObserver(() => {
            const width = this.screens.clientWidth;
            if (width !== this.lastWidth) {
              this.lastWidth = width;
              this.go(this.index, false);
            } else this.fit();
          });
          this.slides.forEach(slide => this.observer.observe(slide));
        });
      }
      go(requested, animate = true) {
        const index = Math.min(this.slides.length - 1, Math.max(0, requested));
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.screens.scrollTo({ left: index * this.screens.clientWidth, behavior: animate && !reduce ? 'smooth' : 'instant' });
        if (!animate || reduce) this.update(index);
      }
      update(index) {
        this.index = index;
        this.features.forEach((button, current) => button.setAttribute('aria-pressed', String(current === index)));
        this.dots.forEach((button, current) => button.setAttribute('aria-pressed', String(current === index)));
        this.slides.forEach((slide, current) => {
          slide.inert = current !== index;
          slide.setAttribute('aria-hidden', String(current !== index));
        });
        this.fit();
      }
      fit() {
        const height = this.slides[this.index]?.offsetHeight;
        if (height) this.screens.style.height = `${height}px`;
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aa-installation"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('de-wallbox-installation-slider')) {
    customElements.define('de-wallbox-installation-slider', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const controller = this.controller;
        queueMicrotask(() => {
          if (!this.isConnected || controller.signal.aborted) return;
          this.viewport = this.querySelector('[data-viewport]');
          this.slides = Array.from(this.querySelectorAll('[data-slide]'));
          if (!this.viewport || !this.slides.length) return;
          this.buttons = Array.from(this.querySelectorAll('[data-slide-button]'));
          this.previous = this.querySelector('[data-previous]');
          this.next = this.querySelector('[data-next]');
          this.controls = this.querySelector('[data-controls]');
          this.status = this.querySelector('[data-status]');
          this.index = 0;
          this.lastWidth = this.viewport.clientWidth;
          this.drag = null;
          const options = { signal: controller.signal };
          this.classList.add('is-ready');
          [this.previous, this.next, this.controls].forEach(node => { if (node) node.hidden = false; });
          this.update(0);
          this.viewport.scrollTo({ left: 0, behavior: 'instant' });

          this.addEventListener('click', event => {
            if (event.target.closest('[data-previous]')) this.go(this.index - 1);
            if (event.target.closest('[data-next]')) this.go(this.index + 1);
            const button = event.target.closest('[data-slide-button]');
            if (button && this.buttons.includes(button)) this.go(Number(button.dataset.slideButton));
          }, options);
          this.addEventListener('keydown', event => {
            if (event.target.closest('input, textarea, select, [contenteditable="true"]')) return;
            let index;
            if (event.key === 'ArrowRight') index = this.index + 1;
            if (event.key === 'ArrowLeft') index = this.index - 1;
            if (event.key === 'Home') index = 0;
            if (event.key === 'End') index = this.slides.length - 1;
            if (index === undefined) return;
            event.preventDefault();
            this.go(index);
          }, options);
          this.viewport.addEventListener('scroll', () => {
            if (this.frame) cancelAnimationFrame(this.frame);
            this.frame = requestAnimationFrame(() => {
              this.frame = null;
              if (!this.drag) this.update(this.nearest());
            });
            clearTimeout(this.settleTimer);
            this.settleTimer = setTimeout(() => {
              if (this.drag) return;
              this.update(this.nearest());
              if (this.status) this.status.textContent = this.slides[this.index].getAttribute('aria-label');
            }, 160);
          }, { ...options, passive: true });
          this.viewport.addEventListener('pointerdown', event => {
            if (event.pointerType !== 'mouse' || event.button !== 0 || this.slides.length < 2) return;
            if (event.target.closest('a, button')) return;
            this.drag = { id: event.pointerId, startX: event.clientX, left: this.viewport.scrollLeft, moved: false };
            this.viewport.setPointerCapture(event.pointerId);
          }, options);
          this.viewport.addEventListener('pointermove', event => {
            if (!this.drag || this.drag.id !== event.pointerId) return;
            const delta = event.clientX - this.drag.startX;
            if (Math.abs(delta) < 6 && !this.drag.moved) return;
            this.drag.moved = true;
            this.viewport.classList.add('is-dragging');
            event.preventDefault();
            this.viewport.scrollLeft = this.drag.left - delta;
          }, options);
          const finishDrag = event => {
            if (!this.drag || this.drag.id !== event.pointerId) return;
            const moved = this.drag.moved;
            const distance = this.viewport.scrollLeft - this.drag.left;
            const start = Math.round(this.drag.left / (this.viewport.clientWidth || 1));
            const threshold = Math.min(100, this.viewport.clientWidth * 0.15);
            const index = Math.abs(distance) >= threshold ? start + Math.sign(distance) : start;
            this.drag = null;
            this.viewport.classList.remove('is-dragging');
            if (this.viewport.hasPointerCapture(event.pointerId)) this.viewport.releasePointerCapture(event.pointerId);
            if (moved) this.go(index);
          };
          this.viewport.addEventListener('pointerup', finishDrag, options);
          this.viewport.addEventListener('pointercancel', finishDrag, options);
          this.viewport.addEventListener('lostpointercapture', finishDrag, options);
          this.addEventListener('shopify:block:select', event => {
            const slide = event.target.closest('[data-slide]');
            const index = this.slides.indexOf(slide);
            if (index !== -1) this.go(index, false);
          }, options);
          this.resizeObserver = new ResizeObserver(() => {
            const width = this.viewport.clientWidth;
            if (width !== this.lastWidth) {
              this.lastWidth = width;
              this.drag = null;
              this.viewport.classList.remove('is-dragging');
              this.go(this.index, false);
            } else {
              this.fit();
            }
          });
          this.slides.forEach(slide => this.resizeObserver.observe(slide));
        });
      }
      nearest() {
        const width = this.viewport.clientWidth;
        return width ? Math.min(this.slides.length - 1, Math.max(0, Math.round(this.viewport.scrollLeft / width))) : 0;
      }
      go(requested, animate = true) {
        const index = Math.min(this.slides.length - 1, Math.max(0, requested));
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.viewport.scrollTo({ left: index * this.viewport.clientWidth, behavior: animate && !reduce ? 'smooth' : 'instant' });
        if (!animate || reduce) this.update(index);
      }
      update(index) {
        this.index = index;
        this.slides.forEach((slide, current) => {
          const selected = current === index;
          if (!selected && slide.contains(document.activeElement)) this.viewport.focus({ preventScroll: true });
          slide.inert = !selected;
          slide.setAttribute('aria-hidden', String(!selected));
        });
        this.buttons.forEach((button, current) => button.setAttribute('aria-pressed', String(current === index)));
        if (this.previous) this.previous.disabled = index === 0;
        if (this.next) this.next.disabled = index === this.slides.length - 1;
        this.fit();
      }
      fit() {
        const slide = this.slides[this.index];
        if (!slide) return;
        const height = slide.offsetHeight;
        if (height) this.viewport.style.height = `${height}px`;
        const media = slide.querySelector('.de-installation__media');
        if (media) this.style.setProperty('--de-arrow-y', `${media.offsetTop + media.offsetHeight / 2}px`);
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.resizeObserver?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
        clearTimeout(this.settleTimer);
        this.frame = null;
        this.drag = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aa-lcd"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('de-wallbox-lcd-status')) {
    customElements.define('de-wallbox-lcd-status', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const controller = this.controller;
        queueMicrotask(() => {
          if (!this.isConnected || controller.signal.aborted) return;
          this.buttons = Array.from(this.querySelectorAll('[data-state-button]'));
          this.descriptions = Array.from(this.querySelectorAll('[data-state-description]'));
          this.images = Array.from(this.querySelectorAll('[data-state-image]'));
          this.baseImage = this.querySelector('[data-base-image]');
          const stateOptions = { signal: controller.signal };
          if (this.buttons.length) {
            const initial = Number.parseInt(this.dataset.initialIndex, 10) || 0;
            this.selectState(Math.min(Math.max(initial, 0), this.buttons.length - 1));
            this.buttons.forEach(button => { button.disabled = false; });
          }
          this.addEventListener('click', event => {
            const index = this.buttons.indexOf(event.target.closest('[data-state-button]'));
            if (index !== -1) this.selectState(index);
          }, stateOptions);
          this.addEventListener('keydown', event => {
            const index = this.buttons.indexOf(event.target.closest('[data-state-button]'));
            if (index === -1) return;
            let next;
            if (event.key === 'ArrowRight') next = (index + 1) % this.buttons.length;
            if (event.key === 'ArrowLeft') next = (index - 1 + this.buttons.length) % this.buttons.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = this.buttons.length - 1;
            if (next === undefined) return;
            event.preventDefault();
            this.selectState(next);
            this.buttons[next].focus({ preventScroll: true });
          }, stateOptions);
          this.addEventListener('shopify:block:select', event => {
            const index = this.buttons.indexOf(event.target.closest('[data-state-button]'));
            if (index !== -1) this.selectState(index);
          }, stateOptions);
          this.dialog = this.querySelector('[data-guide-dialog]');
          this.trigger = this.querySelector('[data-open-guide]');
          if (!this.dialog || !this.trigger || typeof this.dialog.showModal !== 'function') return;
          this.trigger.disabled = false;
          this.backdropStart = false;
          const options = { signal: controller.signal };
          this.addEventListener('click', event => {
            if (event.target.closest('[data-open-guide]') === this.trigger && !this.dialog.open) {
              this.dialog.showModal();
              this.dialog.scrollTop = 0;
            }
            if (event.target.closest('[data-close-guide]') && this.dialog.open) this.dialog.close();
          }, options);
          this.dialog.addEventListener('pointerdown', event => {
            this.backdropStart = event.target === this.dialog && this.outside(event);
          }, options);
          this.dialog.addEventListener('click', event => {
            if (event.target === this.dialog && this.backdropStart && this.outside(event)) this.dialog.close();
            this.backdropStart = false;
          }, options);
          this.dialog.addEventListener('close', () => {
            this.backdropStart = false;
            if (this.isConnected && this.trigger.isConnected) this.trigger.focus({ preventScroll: true });
          }, options);
        });
      }
      selectState(index) {
        this.buttons.forEach((button, current) => button.setAttribute('aria-pressed', String(current === index)));
        this.descriptions.forEach(description => { description.hidden = Number(description.dataset.stateDescription) !== index; });
        let hasImage = false;
        this.images.forEach(image => {
          const selected = Number(image.dataset.stateImage) === index;
          image.hidden = !selected;
          if (selected) hasImage = true;
        });
        if (this.baseImage) this.baseImage.hidden = hasImage;
      }
      outside(event) {
        const rect = this.dialog.getBoundingClientRect();
        return event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
      }
      disconnectedCallback() {
        if (this.dialog?.open) this.dialog.close();
        this.controller?.abort();
        this.controller = null;
      }
    });
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aa-lengths"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('de-wallbox-cable-lengths')) {
    customElements.define('de-wallbox-cable-lengths', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const controller = this.controller;
        queueMicrotask(() => {
          if (!this.isConnected || controller.signal.aborted) return;
          this.tabs = Array.from(this.querySelectorAll('[data-length-tab]'));
          this.panels = Array.from(this.querySelectorAll('[data-length-panel]'));
          this.nav = this.querySelector('[data-nav]');
          if (!this.tabs.length || this.tabs.length !== this.panels.length) return;
          const initial = Number.parseInt(this.dataset.initialIndex, 10) || 0;
          this.select(Math.min(Math.max(initial, 0), this.tabs.length - 1), false, false);
          const options = { signal: controller.signal };
          this.addEventListener('click', event => {
            const index = this.tabs.indexOf(event.target.closest('[data-length-tab]'));
            if (index !== -1) this.select(index);
          }, options);
          this.addEventListener('keydown', event => {
            const index = this.tabs.indexOf(event.target.closest('[data-length-tab]'));
            if (index === -1) return;
            let next;
            if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
            if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = this.tabs.length - 1;
            if (next === undefined) return;
            event.preventDefault();
            this.select(next, true);
          }, options);
          this.addEventListener('shopify:block:select', event => {
            const index = this.panels.indexOf(event.target.closest('[data-length-panel]'));
            if (index !== -1) this.select(index, false, false);
          }, options);
        });
      }
      select(index, focus = false, animate = true) {
        this.tabs.forEach((tab, current) => {
          const active = index === current;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
        });
        this.panels.forEach((panel, current) => {
          if (current !== index && panel.contains(document.activeElement)) focus = true;
          panel.hidden = current !== index;
        });
        const tab = this.tabs[index];
        if (this.nav && this.nav.scrollWidth > this.nav.clientWidth) {
          const left = tab.offsetLeft - (this.nav.clientWidth - tab.offsetWidth) / 2;
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.nav.scrollTo({ left: Math.max(0, left), behavior: animate && !reduce ? 'smooth' : 'instant' });
        }
        if (focus) tab.focus({ preventScroll: true });
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aa-operation"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('de-wallbox-operation-demo')) {
    customElements.define('de-wallbox-operation-demo', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const controller = this.controller;
        queueMicrotask(() => {
          if (!this.isConnected || controller.signal.aborted) return;
          this.rows = Array.from(this.querySelectorAll('[data-operation-row]'));
          const options = { signal: controller.signal };
          this.querySelectorAll('button, input').forEach(control => { control.disabled = false; });
          this.addEventListener('click', event => {
            const row = event.target.closest('[data-operation-row]');
            if (!this.rows.includes(row)) return;
            const action = event.target.closest('[data-operation-action]');
            const current = event.target.closest('[data-current-value]');
            const time = event.target.closest('[data-time-index]');
            if (!action && !current && !time) return;
            this.highlight(row);
            if (row.dataset.operation === 'current') {
              const buttons = Array.from(row.querySelectorAll('[data-current-value]'));
              const selected = buttons.findIndex(button => button.getAttribute('aria-pressed') === 'true');
              const target = current || buttons[(selected + 1) % buttons.length];
              this.setCurrent(row, target.dataset.currentValue);
            }
            if (row.dataset.operation === 'wifi' && action) {
              const enabled = action.getAttribute('aria-pressed') !== 'true';
              action.setAttribute('aria-pressed', String(enabled));
              row.classList.toggle('is-pairing', enabled);
              const output = row.querySelector('[data-wifi-output]');
              output.textContent = enabled ? output.dataset.activeText : output.dataset.idleText;
            }
            if (row.dataset.operation === 'schedule') {
              const range = row.querySelector('[data-time-range]');
              const index = time ? Number(time.dataset.timeIndex) : (Number(range.value) + 1) % 5;
              this.setTime(row, index);
            }
          }, options);
          this.addEventListener('input', event => {
            const range = event.target.closest('[data-time-range]');
            if (!range) return;
            const row = range.closest('[data-operation-row]');
            if (!this.rows.includes(row)) return;
            this.highlight(row);
            this.setTime(row, Number(range.value));
          }, options);
          this.addEventListener('shopify:block:select', event => {
            const row = event.target.closest('[data-operation-row]');
            if (this.rows.includes(row)) this.highlight(row);
          }, options);
        });
      }
      highlight(row) {
        this.rows.forEach(item => item.classList.toggle('is-active', item === row));
      }
      setCurrent(row, value) {
        row.querySelectorAll('[data-current-value]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.currentValue === value)));
        row.querySelector('[data-current-output]').textContent = `${value}A`;
      }
      setTime(row, requested) {
        const times = ['0.5', '2', '4', '6', '8'];
        const index = Math.min(4, Math.max(0, Math.round(requested) || 0));
        const label = `${times[index]}h`;
        const range = row.querySelector('[data-time-range]');
        range.value = String(index);
        range.setAttribute('aria-valuetext', label);
        range.style.setProperty('--progress', `${index * 25}%`);
        row.querySelectorAll('[data-time-index]').forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.timeIndex) === index)));
        row.querySelector('[data-time-output]').textContent = label;
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aa-rfid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('de-wallbox-manual-rfid')) {
    customElements.define('de-wallbox-manual-rfid', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const controller = this.controller;
        queueMicrotask(() => {
          if (!this.isConnected || controller.signal.aborted) return;
          this.dialog = this.querySelector('[data-rfid-dialog]');
          this.trigger = this.querySelector('[data-open-rfid]');
          if (!this.dialog || !this.trigger || typeof this.dialog.showModal !== 'function') return;
          this.trigger.disabled = false;
          this.backdropStart = false;
          const options = { signal: controller.signal };
          this.addEventListener('click', event => {
            if (event.target.closest('[data-open-rfid]') === this.trigger && !this.dialog.open) {
              this.dialog.showModal();
              this.dialog.scrollTop = 0;
            }
            if (event.target.closest('[data-close-rfid]') && this.dialog.open) this.dialog.close();
          }, options);
          this.dialog.addEventListener('pointerdown', event => {
            this.backdropStart = event.target === this.dialog && this.outside(event);
          }, options);
          this.dialog.addEventListener('click', event => {
            if (event.target === this.dialog && this.backdropStart && this.outside(event)) this.dialog.close();
            this.backdropStart = false;
          }, options);
          this.dialog.addEventListener('close', () => {
            this.backdropStart = false;
            if (this.isConnected && this.trigger.isConnected) this.trigger.focus({ preventScroll: true });
          }, options);
        });
      }
      outside(event) {
        const rect = this.dialog.getBoundingClientRect();
        return event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
      }
      disconnectedCallback() {
        if (this.dialog?.open) this.dialog.close();
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aa-wallbox-features"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('de-uk-wallbox-features-v3')) {
    customElements.define('de-uk-wallbox-features-v3', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const controller = this.controller;
        queueMicrotask(() => {
          if (!this.isConnected || controller.signal.aborted) return;
          this.cards = Array.from(this.querySelectorAll('[data-feature-card]'));
          if (!this.cards.length) return;
          const initial = Number.parseInt(this.dataset.initialIndex, 10) || 0;
          this.selectCard(Math.min(Math.max(initial, 0), this.cards.length - 1));
          const options = { signal: controller.signal };
          this.addEventListener('click', (event) => {
            const card = event.target.closest('[data-feature-card]');
            const index = this.cards.indexOf(card);
            if (index !== -1) this.selectCard(index);
          }, options);
          this.addEventListener('keydown', (event) => {
            const index = this.cards.indexOf(event.target.closest('[data-feature-card]'));
            if (index === -1) return;
            let next;
            if (event.key === 'ArrowRight') next = (index + 1) % this.cards.length;
            if (event.key === 'ArrowLeft') next = (index - 1 + this.cards.length) % this.cards.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = this.cards.length - 1;
            if (next === undefined) return;
            event.preventDefault();
            this.selectCard(next);
            this.cards[next].focus({ preventScroll: true });
          }, options);
          this.addEventListener('shopify:block:select', (event) => {
            const index = this.cards.indexOf(event.target.closest('[data-feature-card]'));
            if (index !== -1) this.selectCard(index);
          }, options);
        });
      }
      selectCard(index) {
        this.cards.forEach((card, current) => {
          const selected = index === current;
          card.classList.toggle('is-selected', selected);
          card.setAttribute('aria-pressed', String(selected));
        });
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.cards = [];
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["halloween-charge-pumpkin"] && !Shopify.designMode) return;
  try {
    
  (()=>{const init=root=>{if(!root||root.dataset.ready)return;root.dataset.ready='1';let level=0;const scene=root.querySelector('.hcharge__scene'),charger=root.querySelector('[data-hcharge-charger]'),pumpkin=root.querySelector('[data-hcharge-pumpkin]'),fill=root.querySelector('[data-hcharge-fill]'),pumpkinFill=root.querySelector('[data-hcharge-pumpkin-fill]'),percent=root.querySelector('[data-hcharge-percent]'),status=root.querySelector('[data-hcharge-status]'),button=root.querySelector('[data-hcharge-button]'),buttonText=root.querySelector('[data-hcharge-button-text]'),reset=root.querySelector('[data-hcharge-reset]'),reward=root.querySelector('[data-hcharge-reward]'),ready=status.textContent,label=buttonText.textContent;button.addEventListener('click',()=>{level=Math.min(100,level+25);fill.style.width=level+'%';pumpkinFill.style.width=level+'%';percent.textContent=level+'%';scene.classList.add('is-active');charger.classList.add('is-live');status.textContent=level<100?'Energy flowing to the pumpkin…':'Pumpkin fully charged';buttonText.textContent=level<100?'Keep charging':'Fully charged';if(level===100){pumpkin.classList.add('is-charged');reward.hidden=false;button.hidden=true;reset.hidden=false;setTimeout(()=>scene.classList.remove('is-active'),1400)}});reset.addEventListener('click',()=>{level=0;fill.style.width='0%';pumpkinFill.style.width='0%';percent.textContent='0%';status.textContent=ready;buttonText.textContent=label;scene.classList.remove('is-active');charger.classList.remove('is-live');pumpkin.classList.remove('is-charged');reward.hidden=true;button.hidden=false;reset.hidden=true})};document.querySelectorAll('[data-hcharge]').forEach(init);document.addEventListener('shopify:section:load',e=>init(e.target.querySelector('[data-hcharge]')))})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["halloween-find-pumpkin"] && !Shopify.designMode) return;
  try {
    
  (()=>{const init=root=>{if(!root||root.dataset.ready)return;root.dataset.ready='1';const buttons=root.querySelectorAll('[data-hfp-pumpkin]'),reward=root.querySelector('[data-hfp-reward]'),message=root.querySelector('[data-hfp-message]');let winner=Number(root.dataset.winner)||5;buttons.forEach(btn=>btn.addEventListener('click',()=>{if(Number(btn.dataset.position)===winner){btn.classList.add('is-found');buttons.forEach(x=>x.disabled=true);message.textContent='You found it!';reward.hidden=false}else{btn.classList.remove('is-wrong');void btn.offsetWidth;btn.classList.add('is-wrong');message.textContent='Not charged — try another pumpkin'}}));root.querySelector('[data-hfp-reset]').addEventListener('click',()=>{reward.hidden=true;message.textContent='Choose a pumpkin';buttons.forEach(x=>{x.disabled=false;x.className=''})})};document.querySelectorAll('[data-hfp-root]').forEach(init);document.addEventListener('shopify:section:load',e=>init(e.target.querySelector('[data-hfp-root]')))})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["halloween-pumpkin-collection"] && !Shopify.designMode) return;
  try {
    
  (()=>{const init=root=>{if(!root||root.dataset.ready)return;root.dataset.ready='1';const items=[...root.querySelectorAll('[data-hpc-item]')],count=root.querySelector('[data-hpc-count]'),fill=root.querySelector('[data-hpc-fill]'),reward=root.querySelector('[data-hpc-reward]');const render=()=>{const n=items.filter(x=>x.classList.contains('is-found')).length;count.textContent=n+' / 3';fill.style.width=(n/3*100)+'%';if(n===3)reward.hidden=false};items.forEach(item=>item.addEventListener('click',()=>{item.classList.add('is-found');item.disabled=true;render()}));root.querySelector('[data-hpc-reset]').addEventListener('click',()=>{items.forEach(x=>{x.disabled=false;x.classList.remove('is-found')});reward.hidden=true;render()})};document.querySelectorAll('[data-hpc-root]').forEach(init);document.addEventListener('shopify:section:load',e=>init(e.target.querySelector('[data-hpc-root]')))})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["halloween-pumpkin-hunt-finale"] && !Shopify.designMode) return;
  try {
    
  (()=>{const key='deHalloweenPumpkinsV2',read=()=>{try{return JSON.parse(sessionStorage.getItem(key)||'[]')}catch(e){return[]}},render=()=>{const found=read();document.querySelectorAll('[data-hhunt-final]').forEach(root=>{root.querySelector('[data-hhunt-final-count]').textContent=found.length;root.querySelectorAll('[data-hhunt-icon]').forEach(i=>i.classList.toggle('is-found',found.includes(i.dataset.hhuntIcon)));root.querySelector('[data-hhunt-final-reward]').hidden=found.length<3})};document.addEventListener('de:halloween-hunt',render);document.querySelectorAll('[data-hhunt-final]').forEach(root=>root.querySelector('[data-hhunt-final-reset]').addEventListener('click',()=>{if(window.deHalloweenHuntReset)window.deHalloweenHuntReset();render()}));document.addEventListener('shopify:section:load',render);render()})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["halloween-pumpkin-hunt-stop"] && !Shopify.designMode) return;
  try {
    
  (()=>{const key='deHalloweenPumpkinsV2',get=()=>{try{return JSON.parse(sessionStorage.getItem(key)||'[]')}catch(e){return[]}},save=v=>{try{sessionStorage.setItem(key,JSON.stringify(v))}catch(e){}};const update=()=>{const found=get();document.querySelectorAll('[data-hhunt-stop]').forEach(root=>{const id=String(root.dataset.hhuntStop),done=found.includes(id),button=root.querySelector('[data-hhunt-pumpkin]');root.querySelector('[data-hhunt-count]').textContent=found.length;root.querySelector('[data-hhunt-progress]').style.width=Math.min(100,found.length/3*100)+'%';button.classList.toggle('is-found',done);button.disabled=done;root.querySelector('[data-hhunt-found]').hidden=!done});document.dispatchEvent(new CustomEvent('de:halloween-hunt',{detail:{found}}))};const init=root=>{if(!root||root.dataset.ready)return;root.dataset.ready='1';root.querySelector('[data-hhunt-pumpkin]').addEventListener('click',()=>{const found=get(),id=String(root.dataset.hhuntStop);if(!found.includes(id)){found.push(id);save(found)}update()});update()};document.querySelectorAll('[data-hhunt-stop]').forEach(init);document.addEventListener('shopify:section:load',e=>init(e.target.querySelector('[data-hhunt-stop]')));window.deHalloweenHuntReset=()=>{save([]);update()}})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["halloween-pumpkin-personality"] && !Shopify.designMode) return;
  try {
    
  (()=>{const init=root=>{if(!root||root.dataset.ready)return;root.dataset.ready='1';const result=root.querySelector('[data-hpp-result]'),cards=root.querySelectorAll('[data-hpp-choice]');cards.forEach(card=>card.addEventListener('click',()=>{root.querySelector('[data-hpp-title]').textContent=card.dataset.title;root.querySelector('[data-hpp-copy]').textContent=card.dataset.copy;result.hidden=false;cards.forEach(x=>x.setAttribute('aria-pressed',x===card?'true':'false'));result.scrollIntoView({behavior:'smooth',block:'nearest'})}));root.querySelector('[data-hpp-reset]').addEventListener('click',()=>{result.hidden=true;cards.forEach(x=>x.removeAttribute('aria-pressed'))})};document.querySelectorAll('[data-hpp-root]').forEach(init);document.addEventListener('shopify:section:load',e=>init(e.target.querySelector('[data-hpp-root]')))})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
